// src/Pages/Home/Home.jsx
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Home.css';
// import FAQ from './FAQ.jsx';
import Sigueme from './Sigueme.jsx';

import ServiceCategoryContainer from '../../Components/Cards/ServiceCategoryContainer.jsx';
import CtaBanner from '../../Components/CtaBanner/CtaBanner.jsx';
import Review from '../../Components/Comentarios/Review.jsx';
import PhotographerCard from '../../Components/Card-personal/PhotographerCard.jsx';
// import Inspiration from '../../Components/Cards/Inspiration/Inspiration.jsx';
  import Carousel from './Carrousel.js';
// import BackgroundVideo from '../Admin/Components/BackgroundVideo.js';
import Footer from '../../Components/Footer/Footer.jsx';
// import Frase from '../../Components/Cards/frases/Frase.jsx';
import HeroSection from './HeroSection.jsx';
// import ReservaSection from './ReservaSection.jsx';
import ComoTrabajamos from './ComoTrabajamos.jsx';
import PolaroidGallery from './PolaroidGallery.jsx'; 

function Home() {
  useEffect(() => {
    AOS.init({ duration: 2000, once: true });
  }, []);

  // Placeholder SVG inline (fallback visual mínimo si la URL pública falla)
  // const placeholder =
  //   'data:image/svg+xml;utf8,' +
  //   encodeURIComponent(
  //     `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600" viewBox="0 0 800 600"><rect width="100%" height="100%" fill="#f3f4f6"/><text x="50%" y="50%" fill="#9ca3af" font-family="Arial, sans-serif" font-size="20" dominant-baseline="middle" text-anchor="middle">Imagen no disponible</text></svg>`
  //   );

  // URLs públicas desde IMAGES (fallback al placeholder si están vacías)
  // const img1Src = IMAGES?.home?.img1 || placeholder;
  // const img2Src = IMAGES?.home?.img2 || placeholder;
  // const img3Src = IMAGES?.home?.img3 || placeholder;

  // const handleImgError = (e) => {
  //   e.currentTarget.onerror = null;
  //   e.currentTarget.src = placeholder;
  //   e.currentTarget.alt = 'Imagen no disponible';
  // };

  // Componente de presentación para Trabajo
  // const WorkPresentation = () => (
  //   <section className="word-section" data-aos="fade-up" aria-label="Presentación de trabajo">
  //     <div className="word-container fade-in">
  //       {/* Texto principal (columna izquierda) */}
  //       <div className="word-text" data-aos="fade-up">
  //         <span className="intro-line">Descubre nuestro arte</span>

  //         <h2 className="photographer-title">
  //           Explora nuestro <span className="name-highlight">Portfolio Profesional</span>
  //         </h2>

  //         <p className="word-description">
  //           Cada imagen cuenta una historia única. Sumérgete en nuestra colección de momentos
  //           capturados con pasión, técnica y una visión artística excepcional.
  //         </p>
  //       </div>

  //       {/* Panel derecho: mini-gallery y CTA suave */}
  //       <aside className="word-panel" data-aos="fade-up" data-aos-delay="120">
  //         <div className="mini-gallery" role="list" aria-label="Mini galería de trabajos">
  //           <div className="item" role="listitem">
  //             <img src={img1Src} alt="Preview portfolio 1" onError={handleImgError} />
  //           </div>
  //           <div className="item" role="listitem">
  //             <img src={img2Src} alt="Preview portfolio 2" onError={handleImgError} />
  //           </div>
  //           <div className="item" role="listitem">
  //             <img src={img3Src} alt="Preview portfolio 3" onError={handleImgError} />
  //           </div>
  //         </div>
  //       </aside>
  //     </div>

  //     {/* Elementos decorativos flotantes (oblongo) */}
  //     <div className="floating-elements" aria-hidden="true">
  //       <span className="floating-oblongo obl-1"></span>
  //       <span className="floating-oblongo obl-2"></span>
  //       <span className="floating-oblongo obl-3"></span>
  //       <div className="accent-line"></div>
  //     </div>
  //   </section>
  // );

  // Componente de presentación para Reviews
  // const ReviewsPresentation = () => (
    <section className="test-section" data-aos="fade-up">
      <div className="test-container fade-in">
        {/* Texto principal */}
        <div className="test-text">
          <span className="intro-line">Testimonios reales</span>
          <h2 className="photographer-title">
            Lo que dicen nuestros <span className="name-highlight">Clientes Satisfechos</span>
          </h2>
          <p className="inspiration-description">
            Las palabras de nuestros clientes son nuestro mejor respaldo. 
            Descubre por qué confían en nosotros para capturar sus momentos más especiales.
          </p>
        </div>
      </div>

      {/* Elementos decorativos */}
      <div className="floating-elements" aria-hidden="true">
        <span className="floating-circle circle-1"></span>
        <span className="floating-circle circle-2"></span>
        <span className="floating-circle circle-3"></span>
      </div>
    </section>
  // );

  return (
    <div>
      <HeroSection/>
      
      <div data-aos="fade-up">
        <PhotographerCard/>
          <Carousel/>
      </div>

      {/* Sección de Trabajo con presentación */}
      <div id='trabajo'>
        <ComoTrabajamos />
        {/* <Frase/> */}
        <div data-aos="fade-up">
          <PolaroidGallery/>
        </div>
      </div>

      {/* Sección de Servicios con presentación */}
      <div id='servicios' data-aos="fade-up">
        <ServiceCategoryContainer/>
      </div>
      <CtaBanner/>

      {/* Sección de Reviews con presentación */}
      {/* <ReviewsPresentation /> */}
      <div data-aos="fade-up">
        <Review/>
        {/* <FAQ/> */}
      </div>

      {/* Sección de Reserva e Inspiración */}
      <div id='reserva' data-aos="fade-up">
        {/* <ReservaSection/> */}
      </div>
      <div id='inspiracion' data-aos="fade-up">
        {/* <Inspiration/> */}
      </div>

      <Sigueme/>
      <Footer/>
    </div>
  );
}

export default Home;
